export const VisibilityBasic = `
<div>
  <div class="visible">Visible</div>
  <div class="invisible">Invisible</div>
</div>
  `
